import { render, staticRenderFns } from "./Warningblock.vue?vue&type=template&id=72a8387e&"
import script from "./Warningblock.vue?vue&type=script&lang=js&"
export * from "./Warningblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports